import { StatusBar, StyleSheet } from 'react-native';

import { COLOR, lightGrey } from 'utils/colors';
import {
    androidScreenMarginBottom,
    isPhone,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const PROVIDER_LOGO_HEIGHT = 59;
const PROVIDER_LOGO_BOTTOM_MARGIN = 8;

const styles = StyleSheet.create({
    safeArea: {
        flex: 1,
        backgroundColor: COLOR.BLACK,
        alignItems: 'center',
        marginBottom: androidScreenMarginBottom,
    },
    webSafeArea: {
        justifyContent: 'center',
    },
    webContainer: {
        flex: 1,
    },
    phoneContainer: {
        flex: 1,
        marginTop: 40 + (StatusBar.currentHeight || 0),
    },
    title: {
        marginHorizontal: 16,
        textAlign: 'center',
        lineHeight: 40,
        width: isTabletOrWeb ? widthPercentageToDP(480) : undefined,
    },
    description: {
        marginTop: 16,
        marginHorizontal: 16,
        textAlign: 'center',
        color: lightGrey(0.7),
        lineHeight: 19.6,
        width: isTabletOrWeb ? widthPercentageToDP(480) : undefined,
    },
    stripe: {
        marginTop: 40,
        flexGrow: 0,
        height: isTablet
            ? (PROVIDER_LOGO_HEIGHT + PROVIDER_LOGO_BOTTOM_MARGIN) * 2
            : PROVIDER_LOGO_HEIGHT + PROVIDER_LOGO_BOTTOM_MARGIN,
    },
    contentContainerStyle: {
        ...(isTablet && {
            flexWrap: 'wrap',
            maxWidth: 568,
            justifyContent: 'center',
        }),
        paddingHorizontal: isPhone ? 16 : undefined,
    },
    logo: {
        width: 104,
        height: 59,
        borderRadius: 3,
        marginBottom: 8,
    },
    logoIndent: { marginRight: 8 },
    buttonsContainer: {
        marginTop: isTabletOrWeb ? 40 : 5,
        marginBottom: 32,
        alignSelf: 'center',
        flexDirection: isPhone ? 'column' : 'row',
        justifyContent: 'center',
    },
    button: {
        marginTop: isPhone ? 12 : 0,
        minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328),
        width: 'auto',
        backgroundColor: COLOR.primary,
        borderColor: COLOR.primary,
    },
    actionButtonText: {
        color: COLOR.BLACK,
    },
});

export default styles;
